import React, { Component } from "react";
import { isDesktop } from "react-device-detect";
import { Redirect } from "react-router-dom";
import Image from "../../../base/features/micro/Image";
import actionHandler from "../../../base/utils/action_handler";
import checkOrientation from "../../../base/utils/check_orientation";

class DynamicAccessory extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="row mx-0 mb-4 px-4">
        {this.state.actionUrl && <Redirect push to={this.state.actionUrl} />}
        <div
          style={{
            color: this.props.view.title_color,
            fontSize: this.props.view.title_size + "px",
          }}
          className={`col-12 px-0 fw-bold`}
        >
          {this.props.view.title}
        </div>
        <div className="px-0 py-3 row mx-0">
          {this.props.view.items?.map((item, i) => (
            <div
              className="col-12 p-3 bg-white shadow-sm rounded14 mb-3"
              style={{
                background: `linear-gradient(${checkOrientation(
                  item.background_color_orientation
                )}${item.background_color},${
                  item.background_color_end || item.background_color
                })`,
              }}
              onClick={() =>
                this.setState({
                  actionUrl: actionHandler(
                    item.action,
                    item.action_data,
                    item.title
                  ),
                })
              }
            >
              <div className="row mx-0 px-0">
                <div className="col-8 px-1">
                  <div className="px-2">
                    <p
                      className="mb-3 mt-2 fw-bold"
                      style={{
                        color: item.title_color,
                        fontSize: item.title_size + "px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.title}
                    </p>
                    <p
                      className="mt-2 small fw-bold"
                      style={{
                        whiteSpace: "pre-wrap",
                        fontSize: item.description_size,
                        color: item.description_color,
                      }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
                <div className="col-4 px-1 align-self-center" dir="ltr">
                  <Image
                    imageUri={item.media && item.media.file}
                    imgClassName={`d-block ${isDesktop ? "w-75" : "w-100"}`}
                    extraClassName="w-50 d-block rounded14 p-2 mx-auto bg-secondary"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default DynamicAccessory;
